<template>
  <app-dropdown class="user-menu">
    <template v-slot:dropdown-button>
      <img
          :src="require('../../../../assets/img/default-profile.png')"
          class="user-image img-circle elevation-2"
          alt="User Image"
      />
    </template>
    <template v-slot:dropdown-menu>
      <li class="user-header bg-light">
        <img
            :src="require('../../../../assets/img/default-profile.png')"
            class="img-circle elevation-2"
            alt="User Image"
        />
        <p>
          <span>{{user && user.username}}</span>
        </p>
      </li>
      <!-- Menu Footer-->
      <li class="user-footer">
        <b-button @click="logout" class="float-right" variant="outline-secondary">
          {{ $t("Log out") }}
        </b-button>
      </li>
    </template>
  </app-dropdown>
</template>

<script>
import Dropdown from '../../../../components/dropdown/dropdown.vue';

export default {
  name: 'user-dropdown',
  components: {
    'app-dropdown': Dropdown
  },
  computed: {
    user() {
      return this.$store.getters['currentUser'];
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.go();
    },
  }
}

</script>
<style>
.user-menu .user-image {
    width: 1.6rem !important;
    height: 1.6rem !important;
    margin-right: 0 !important;
    margin-left: -8px !important;
}
</style>
